import(/* webpackMode: "eager" */ "/tmp/build/app/page.tsx");
